import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { postData } from '../../utility/Utility';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import CustomLoader from '../../Components/CustomLoader/CustomLoader';

export default function IpAddressModal({ show, onClose, onSelect }) {
  const [ips, setIps] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const rowsPerPage = 10;

  const fetchIps = useCallback(async () => {
    setLoading(true);
    try {
      const response = await postData('api/ip-management/list', {
        status: 'active', 
        page: currentPage + 1,
        limit: rowsPerPage
      });
      setIps(response.data.ips);
      setPageCount(response.data.totalPages);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  }, [currentPage]);

  useEffect(() => {
    fetchIps();
  }, [fetchIps]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleSelect = (ip) => {
    onSelect(ip);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <CustomLoader loading={loading} />
      <Modal.Header closeButton>
        <Modal.Title>Select Active IP Address</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped bordered hover responsive className="ip-list-table">
          <thead>
            <tr>
              <th>IP Address</th>
              <th>Title</th>
              <th className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {ips.map((ip) => (
              <tr key={ip._id}>
                <td>{ip.ipAddress}</td>
                <td>{ip.title}</td>
                <td>
                  <Button 
                    variant="primary" 
                    size="sm"
                    onClick={() => handleSelect(ip)}
                  >
                    Select
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <ReactPaginate
          previousLabel={<i className="mdi mdi-chevron-left"></i>}
          nextLabel={<i className="mdi mdi-chevron-right"></i>}
          pageCount={pageCount}
          onPageChange={handlePageChange}
          containerClassName="pagination pagination-rounded justify-content-end mt-3"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          activeClassName="active"
          forcePage={currentPage}
        />
      </Modal.Body>
    </Modal>
  );
}
